(function () {
    "use strict";

    window.$ = window.jQuery = require("jquery");

    window.moment = require("moment");
    require("moment/min/locales");
    require("moment-timezone");

    window._ = require("lodash");

    window.tinycolor = require("tinycolor2");

    const angular = require("angular");

    require("localforage");
    require("rxjs");
    require("downloadjs");
    require("es6-deferred");

    $.get("/api/system/", {}, data => {
        data.timezone = "UTC";
        data["date_format"].naive = "YYYY-MM-DDTHH:mm:ss";
        data["date_format"].calendar = "YYYY-MM-DDThh:mm:ssZZ";
        moment.tz.guess();
        moment.tz.setDefault("UTC");
        import(
            /* webpackFetchPriority: "high" */
            /* webpackMode: "lazy-once" */
            /* webpackChunkName: "bootstrap" */
            /* webpackPrefetch: true */
            "./core/bootstrap"
        ).then(bootstrap => {
            bootstrap.default(data);
        });
    });
})();
